export class Organisation {
    name: string;
    id: string;
    typ: string;
    eicNummer: string;
    eicNummer2: string;
    eicNummer3: string;
    eicNummerNvnbs: string[];
    schaltleitung: string;
    kundenBetreuer: string;
    emailAdressen: string;
    stromNetzbetreiberNummer: string;
    bemerkung: string;
    zuweisungDeaktiviert: boolean;
    updateDateTime: Date;
    createdDateTime: Date;
}
